import { writable } from 'svelte/store';

import { db, auth, syncTime, unJoin } from '../services/firebase-service';

import { TYPES } from '../utils/constants';

/*
function mnemonic() {
	const mnemonic = window.location.pathname.replace(/[^\w-]+/gi, '').toString().trim();
	const { subscribe, set, update } = writable(mnemonic);

	console.log('window.location mnemonic:', mnemonic);

	return {
		subscribe,
		update,
		set
	};
}

export default mnemonic();
*/


const { subscribe, set, update } = writable({
	mnemonic: null,
	gameID: null,
	gameRef: null,
	game: null,
	playersInput: null,
	authPlayerInput: null
});

let authID;
function setAuthID(newAuthID) {
	console.log('authID', newAuthID);
	authID = newAuthID;
}

let gameID;
let game;
let gameRef;
let unGame;
let unPlayersInput;

async function setMnemonicOrGameIDFromURL() {
	const path = mnemonicOrGameIDFromURL();

	if (!path) {
		if (gameID) {
			await unJoin({ authID, gameID, game });
		}

		gameID = null;
		game = null;
		gameRef = null;
		unGame && unGame();
		unGame = null;
		unPlayersInput && unPlayersInput();
		unPlayersInput = null;

		return await set({ mnemonic: '' });
	}

	const isMnemonic = path.split('-').length === 3;

	if (isMnemonic) {
		await setMnemonic(path);
	}
	else {
		await setGameID(path);
	}
}

function setMnemonic(mnemonic) {
	return new Promise((r, x) => {
		unGame && unGame();
		unGame = null;

		unPlayersInput && unPlayersInput();
		unPlayersInput = null;

		// remove player from current game before changing games
		if (gameID) {
			unJoin({ authID, gameID, game });
		}

		unGame = db.collection('games')
			.where('mnemonic', '==', mnemonic)
			.where('type', '==', TYPES.friends)
			.orderBy('status', 'desc')
			.orderBy('timestampCreated', 'desc')
			.limit(1)
			.onSnapshot(gamesSnap => {
				if (!gamesSnap || !gamesSnap.docs || !gamesSnap.docs[0] || !gamesSnap.docs[0].id) {
					return;
				}
				gameID = gamesSnap.docs[0].id;
				game = gamesSnap.docs[0].data();
				gameRef = db.collection('games').doc(gameID);
				handleGame();
				return r();
			});

	});
}

function setGameID(newGameID) {
	return new Promise(async (r, x) => {
		unGame && unGame();
		unGame = null;

		unPlayersInput && unPlayersInput();
		unPlayersInput = null;

		// remove player from current game before changing games
		if (gameID) {
			unJoin({ authID, gameID, game });
		}

		unGame = db.collection('games').doc(newGameID).onSnapshot(async (gameSnap) => {
			if (!gameSnap || !gameSnap.data) {
				return;
			}

			gameID = gameSnap.id;
			game = gameSnap.data();
			gameRef = db.collection('games').doc(gameID);

			if (!gameID || !game) {
				return;
			}

			handleGame();
			return r();
		});
	});
}

function handleGame() {
	console.log('game loaded', game.mnemonic, gameID);
	!unPlayersInput && listenPlayersInput(); // if not already listening, listen

	const path = mnemonicOrGameIDFromURL();
	const expectedPath = game.type === TYPES.pub ? gameID : game.mnemonic;
	if (path !== expectedPath) {
		window.history.pushState(null, `Careful Clues - ${game.mnemonic}`, `./${expectedPath}`);
	}

	update(gameStore => ({
		...gameStore,
		mnemonic: game.mnemonic,
		gameID,
		game,
		gameRef
	}));

	function listenPlayersInput() {
		let isInitialLoad = true;

		unPlayersInput = gameRef.collection('playersInput').onSnapshot(playersRef => {
			let playersInput = [];
			playersRef.forEach((playerInputRef) => {
				const id = playerInputRef.id;
				const data = playerInputRef.data();
				playersInput.push({ ...data, id });
			});
			console.log('playersInput updated', playersInput);

			const authPlayerInput = playersInput.find(p => p.id === authID);
			const authGamePlayer = game && game.players && game.players.find(p => p.id === authID);

			if (authPlayerInput) {
				if (!authPlayerInput.syncTimeClientMillis) {
					syncTime({ authID, gameID });
				}

				if (authGamePlayer && authPlayerInput && authGamePlayer.team !== authPlayerInput.requestedTeam) {
					gameRef.collection('playersInput').doc(authID).update({ requestedTeam: authGamePlayer.team });
				}
			}

			update(gameStore => ({
				...gameStore,
				playersInput,
				authPlayerInput
			}));

			isInitialLoad = false;
		});
	}
}

function mnemonicOrGameIDFromURL() {
	let path = window.location.pathname;
	if (!path) {
		return '';
	}
	path = path.toString().trim().replace(/[^a-zA-Z0-9-]+/gi, '');
	if (!path) {
		return '';
	}
	return path;
}

export default {
	subscribe,
	setAuthID,
	setMnemonic,
	setGameID,
	setMnemonicOrGameIDFromURL
}
